import React, { useState, useRef, useEffect } from 'react';
import {
  Box,
  Button,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverBody,
  VStack,
  Text,
} from '@chakra-ui/react';
import { ChevronDownIcon } from '@chakra-ui/icons';

const CustomSelect = ({
  value,
  onChange,
  options,
  placeholder = "Seleziona un'opzione",
  size = 'md',
  colorScheme = 'blue',
  variant = 'outline',
  isDisabled = false,
  renderOption,
  renderValue,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(
    options.find((opt) => opt.value === value) || null
  );
  const triggerRef = useRef();

  useEffect(() => {
    setSelectedOption(options.find((opt) => opt.value === value) || null);
  }, [value, options]);

  const handleSelect = (option) => {
    setSelectedOption(option);
    onChange(option.value);
    setIsOpen(false);
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  return (
    <Popover
      isOpen={isOpen}
      onClose={handleClose}
      placement="bottom-start"
      closeOnBlur
    >
      <PopoverTrigger>
        <Button
          ref={triggerRef}
          onClick={() => setIsOpen(!isOpen)}
          rightIcon={<ChevronDownIcon />}
          size={size}
          colorScheme={colorScheme}
          variant={variant}
          isDisabled={isDisabled}
          w="100%"
          justifyContent="space-between"
          textAlign="left"
          _hover={{
            bg: `${colorScheme}.50`,
            borderColor: `${colorScheme}.300`,
          }}
          _focus={{
            boxShadow: `0 0 0 1px var(--chakra-colors-${colorScheme}-500)`,
          }}
        >
          {selectedOption ? (
            renderValue ? (
              renderValue(selectedOption)
            ) : (
              selectedOption.label
            )
          ) : (
            <Text color="gray.500">{placeholder}</Text>
          )}
        </Button>
      </PopoverTrigger>

      <PopoverContent
        w={triggerRef.current?.offsetWidth || 'auto'}
        maxH="300px"
        overflowY="auto"
        shadow="lg"
        border="1px solid"
        borderColor="gray.200"
        _focus={{ outline: 'none' }}
        closeOnBlur
      >
        <PopoverBody p={0}>
          <VStack spacing={0} align="stretch">
            {options.map((option, index) => (
              <Box
                key={option.value || index}
                p={3}
                cursor="pointer"
                _hover={{
                  bg: 'gray.50',
                }}
                _active={{
                  bg: 'gray.100',
                }}
                onClick={() => handleSelect(option)}
                borderBottom={index < options.length - 1 ? '1px solid' : 'none'}
                borderColor="gray.100"
              >
                {renderOption ? (
                  renderOption(option)
                ) : (
                  <Text>{option.label}</Text>
                )}
              </Box>
            ))}
          </VStack>
        </PopoverBody>
      </PopoverContent>
    </Popover>
  );
};

export default CustomSelect;
